import axios from "../utils/axios";

export const getBlogCategories = async () => {
  try {
    const response = await axios.get("/admin/blog-categories");
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch blog categories",
    );
  }
};

export const createBlogCategory = async (categoryData) => {
  try {
    const response = await axios.post("/admin/blog-categories", categoryData);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to create blog category",
    );
  }
};

export const updateBlogCategory = async (categoryId, categoryData) => {
  try {
    const response = await axios.put(
      `/admin/blog-categories/${categoryId}`,
      categoryData,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to update blog category",
    );
  }
};

export const deleteBlogCategory = async (categoryId) => {
  try {
    const response = await axios.delete(
      `/admin/blog-categories/${categoryId}`,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to delete blog category",
    );
  }
};

export const getBlogCategoriesByBlogId = async (blogId) => {
  try {
    const response = await axios.get(`/admin/blogs/${blogId}/categories`);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Failed to fetch categories for blog",
    );
  }
};

export const setBlogCategories = async (blogId, categoryIds) => {
  try {
    const response = await axios.put(
      `/admin/blogs/${blogId}/categories`,
      { categoryIds },
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to set blog categories",
    );
  }
};
